export enum TextBlockTemplate {
	default,
	columned,
}
